<template>
  <div>
    <main-layout
      controlsBg="light"
      :hasControlsBar="false"
      :breadcrumb="getBreadcrumb">
      <div class="container">
        <grid-row  class="margin-top-xl" column-align="center">
          <grid-col col-size="4">
            <div id="header">
              <h1 class="header-title">
                <chevron
                  @click="$router.push({name: 'Workspace'})"/>
                {{ $t('rule.title') }}
              </h1>
              <div class="header-add-rule">
                <safe-with-else-router-link to="/rule/add">
                  <div
                    v-tooltip.left.top-start="$t('rule.addRule')">
                    <font-awesome-icon class="header-add-rule-icon"
                                       :icon="icon.add"/>
                  </div>
                  <div slot="else">
                    <router-link to="/rule">
                      <span
                        v-tooltip.left.top-start="$t('rule.addRule')">
                        <font-awesome-icon class="header-add-rule-icon"
                                           :icon="icon.add"/>
                      </span>
                    </router-link>
                  </div>
                </safe-with-else-router-link>
              </div>
            </div>
            <alert
              v-if="alertVisible"
              :message="alertMessage"
              :type="alertType">
            </alert>
          </grid-col>
        </grid-row>
        <grid-row
          class="margin-top-xl"
          column-align="center">
          <grid-col
            col-size="4">
            <div
              style="display: flex; justify-content: right">
              <tags-filter
                v-model="filterTags"
                :tagsTree="getTagsTreeState"/>
            </div>
          </grid-col>
        </grid-row>
        <grid-row  class="margin-top-m" column-align="center">
          <grid-col col-size="4">
            <table-component
              ref="ruleTable"
              :data="fetchData"
              sort-by="createdAt"
              sort-order="desc"
              :show-caption="false"
              show-filter=false
              class="datatable"
              filter-placeholder=""
              filterNoResults="">
              <!--
              <table-column
                :sortable="false"
                :filterable="false"
                header-class="table-component__minimum__width__column"
                cell-class="text-center">
                <template slot-scope="row">
                  <span
                    v-tooltip.right.top-start="{
                      content: displayFormula(row)
                    }">
                  <font-awesome-icon
                    :id="row"
                    :icon="icon.viewRule"/>
                  </span>
                </template>
              </table-column>
              -->
              <table-column
                show="name"
                header-class="text-left"
                cell-class="table-component__text-left"
                :label="$t('rule.name')">
              </table-column>
              <table-column
                show="multiple"
                header-class="text-left"
                cell-class="table-component__text-left"
                :formatter="ruleTypeFormat"
                :label="$t('rule.type')">
              </table-column>
              <table-column
                show="enabled"
                cell-class="table-component__text-center"
                :label="$t('rule.enabled')"
                :formatter="enableDisableFormatter">
              </table-column>
              <table-column
                show="createdAt"
                cell-class="table-component__text-center"
                data-type="date:LL"
                :label="$t('rule.creationDate')"
                :formatter="dateFormatter">
              </table-column>
              <table-column
                show="owner"
                header-class="text-left"
                cell-class="table-component__text-left"
                :label="$t('rule.createdBy')">
              </table-column>
              <table-column
                :label="$t('variables.tags')"
                :filterable="false"
                :sortable="false">
                <template
                  slot-scope="row">
                  <tags
                    :value="row.tags" />
                </template>
              </table-column>
              <table-column
                label=""
                :sortable="false"
                :filterable="false"
                header-class="table-component__minimum__width__column"
                cell-class="text-center">
                <template slot-scope="row">
                  <font-awesome-icon
                    v-if="row.canShare"
                    :id="row"
                    v-on:click="onShare(row)"
                    :icon="icon.share"
                    class="table-iconset-icon"/>
                  <font-awesome-icon
                    v-else
                    :icon="icon.share"
                    class="table-icon-disabled"/>
                </template>
              </table-column>
              <table-column
                label=""
                :sortable="false"
                :filterable="false"
                header-class="table-component__minimum__width__column"
                cell-class="text-center">
                <template slot-scope="row">
                  <font-awesome-icon
                    v-if="row.canEdit"
                    :id="row"
                    v-on:click="onUpdate(row)"
                    :icon="icon.pencil"
                    class="table-iconset-icon"/>
                  <font-awesome-icon
                    v-else
                    :icon="icon.pencil"
                    class="table-icon-disabled"/>
                </template>
              </table-column>
              <table-column
                label=""
                :sortable="false"
                :filterable="false"
                header-class="table-component__minimum__width__column"
                cell-class="text-center">
                <template slot-scope="row">
                  <font-awesome-icon
                    v-if="row.canDelete"
                    :id="row"
                    v-on:click="onDelete(row)"
                    :icon="icon.trash"
                    class="table-iconset-icon"/>
                  <font-awesome-icon
                    v-else
                    :icon="icon.trash"
                    class="table-icon-disabled"/>
                </template>
              </table-column>
            </table-component>
          </grid-col>
        </grid-row>
      </div>
      <ok-cancel-modal
        v-if="showConfirmationDeleteModal"
        v-on:ok="onDeleteConfirm"
        v-on:cancel="onDeleteCancel"
        :title="deleteModalMessage"
        :message="deleteModalMessage"
        :okButton="$t('commons.delete')"
        :cancelButton="$t('commons.cancel')">
        <div slot="body">
          <ul>
            <li>
              {{ deletingRule.name }}
            </li>
          </ul>
        </div>
      </ok-cancel-modal>
    </main-layout>
  </div>
</template>

<script>
import MainLayout from '../MainLayout';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import {mapActions, mapGetters} from 'vuex';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import {
  faPencilAlt,
  faSlidersH,
  faTrashAlt,
  faKey
} from '@fortawesome/pro-regular-svg-icons';
import {faPlusCircle} from '@fortawesome/pro-solid-svg-icons';
import TableComponent from '@/components/shared/table/components/TableComponent';
import TableColumn from '@/components/shared/table/components/TableColumn';
import Alert from '@/components/shared/alert/Alert';
import OkCancelModal from '@/components/shared/dialogs/OkCancelModal';
import dayjs from 'dayjs';
import BtnPill from '@/components/shared/buttons/BtnPill';
import pagination from '@/components/shared/table/pagination';
import Tags from '@/components/variable/Tags';
import TagsFilter from '@/components/variable/TagsFilter';
import Chevron from '@/components/shared/Chevron';
import SafeWithElseRouterLink from '@/components/shared/SafeWithElseRouterLink';

export default {
  components: {
    SafeWithElseRouterLink,
    TagsFilter,
    Tags,
    MainLayout,
    GridRow,
    GridCol,
    TableComponent,
    TableColumn,
    FontAwesomeIcon,
    OkCancelModal,
    Alert,
    BtnPill,
    Chevron
  },
  data () {
    return {
      deletingRule: -1,
      showConfirmationDeleteModal: false,
      alertVisible: false,
      alertMessage: '',
      alertType: '', // error, warning, success
      deleteModalMessage: '',
      tablePageSize: 10,
      tableState: {
        filter: '',
        page: 1,
        sort: {
          order: '',
          fieldName: ''
        }
      },
      icon: {
        add: faPlusCircle,
        pencil: faPencilAlt,
        trash: faTrashAlt,
        viewRule: faSlidersH,
        share: faKey
      },
      breadcrumb: [
        {link: '/workspace', nameKey: 'menu.workspace'},
        {link: '/rule/list', nameKey: 'rule.title', disabled: true}
      ],
      filterTags: []
    };
  },
  watch: {
    getRules: {
      handler: function () {
        this.$refs.ruleTable.refresh();
      }
    },
    filterTags: {
      handler: function () {
        const query = this.filterTags.length === 0 ? {} : { tags: this.filterTags.join(',') };
        this.$router.push({ query: query });
        this.retrieveRulesForced({context: this, tags: this.filterTags});
      }
    }
  },
  created () {
    const tags = this.$route.query.tags;
    if (tags) {
      this.filterTags = tags.split(',');
    }

    this.retrieveRules({context: this, tags: this.filterTags});
    // this.retrieveVariables({context: this});
    this.retrieveTagsTree({context: this});

    const alert = this.$route.params.alert;
    if (alert !== undefined) {
      showAlert(this, this.$t(alert), 'success');
    }
  },
  computed: {
    ...mapGetters([
      'getVariables',
      'getRules',
      'getLanguageCode',
      'getTagsTreeState'
    ]),
    getBreadcrumb () {
      return this.breadcrumb.map(route => {
        route.name = this.$t(route.nameKey);
        return route;
      });
    }
  },
  methods: {
    onUpdate (rule) {
      if (rule.varOneIds.length > 1) {
        this.$router.push({name: 'RuleGroupal', params: rule});
      } else {
        this.$router.push({name: 'Rule', params: rule});
      }
    },
    onDelete (rule) {
      this.deletingRule = rule;
      this.deleteModalMessage = this.$t('rule.deleteModalMessage');
      this.showConfirmationDeleteModal = true;
    },
    onDeleteConfirm () {
      const id = this.deletingRule.id;
      const ruleName = this.deletingRule.name;
      this.deletingRule = {};
      this.showConfirmationDeleteModal = false;
      this.deleteRule({ context: this, id: id }).then(() => {
        showAlert(this, this.$t('rule.successDelete', {name: ruleName}), 'success');
      }, () => {
        showAlert(this, this.$t('rule.errorDelete', {name: ruleName}), 'error');
      });
    },
    onDeleteCancel () {
      this.deletingRule = {};
      this.showConfirmationDeleteModal = false;
    },
    onShare (rule) {
      this.$router.push({
        name: 'Permissions',
        params: {
          titleKey: 'permission.titleRule',
          type: 'rule',
          id: rule.id,
          breadcrumb: this.breadcrumb
        }});
    },
    displayFormula (variable) {
      let varsOne = '';
      if (variable.varOneIds) {
        variable.varOneIds.forEach(varId => {
          const ruleVariale = getVarById(this.getVariables, varId);
          if (typeof ruleVariale !== 'undefined') {
            varsOne += ruleVariale.label.split('_').join(' ') + '</br>';
          }
        });
      }

      const varTwo = getVarById(this.getVariables, variable.varTwoId);

      if (varsOne !== '') {
        const firstOperands = varsOne;
        const operator = variable.operator;

        let secondOperand = '';
        let varOrConst = varTwo ? 'variable' : 'constant';
        if (varOrConst === 'variable') {
          secondOperand = varTwo.label.split('_').join(' ');
        } else {
          secondOperand = variable.constant;
        }

        return firstOperands + ' <b>' + operator + ' ' + secondOperand + '</b>';
      }

      return '';
    },
    dateFormatter (value) {
      const languageCode = this.getLanguageCode;
      return dayjs(value).locale(languageCode).format('D MMMM YYYY');
    },
    enableDisableFormatter (value) {
      return value ? this.$t('commons.yes') : this.$t('commons.no');
    },
    fetchData ({ page, filter, sort }) {
      const tablePage = pagination.createPage(
        this.getRules,
        this.tableState,
        ['name', 'owner'],
        this.tablePageSize,
        { page, filter, sort });
      this.tableState = tablePage.state;
      return tablePage.result;
    },
    ruleTypeFormat (data) {
      return data ? this.$t('rule.groupal') : this.$t('rule.single');
    },
    ...mapActions([
      'retrieveVariables',
      'retrieveRules',
      'retrieveRulesForced',
      'deleteRule',
      'retrieveTagsTree'
    ])
  }
};

const showAlert = (context, message, type) => {
  context.alertVisible = true;
  context.alertMessage = message;
  context.alertType = type;
  context.showAlert = true;
  setTimeout(() => {
    context.alertVisible = false;
  }, 2000);
};

const getVarById = (list, ref) => {
  const id = Number(ref);
  for (let i = 0; i < list.length; i++) {
    if (id === list[i].value.id) {
      return list[i];
    }
  }
};

</script>

<style lang="scss" >
  @import "src/stylesheets/variables";

  #header {
    display: inline-block;
    width: 100%;
    line-height: 1rem;
  }

  .header-title {
    float: left;
  }

  .header-add-rule {
    float: right;
  }

  .header-add-rule-icon {
    font-size: 3rem;
    color: $secondary;
  }
</style>



// WEBPACK FOOTER //
// src/layouts/rules/RuleList.vue